import { FlatSubmission } from './ListZero.types';

/*
 * Flattens the submission log entries into the rows of the recent submissions
 * table.
 *
 * Not every entry describes a submission the server accepted. One that was
 * refused before it reached the server carries no response, and reading
 * straight through the response used to take the whole screen down rather
 * than the single row. Everything is read defensively so an entry the table
 * cannot fully describe still draws, with the parts it does know.
 */
export function toSubmissionRows(entries?: any[]): FlatSubmission[] {
  return (entries || []).map((entry) => {
    const { createdDate, log } = entry || {};
    const { statusCode, response } = log || {};
    const {
      dataReceived,
      startTime,
      endTime,
      studyId,
      message,
      deletedEmployees,
    } = response || {};

    return {
      statusCode,
      dataReceived,
      startTime,
      endTime,
      studyId,
      message,
      createdDate,
      success: statusCode >= 200 && statusCode < 300,
      deletedEmployees:
        deletedEmployees?.length > 0 ? deletedEmployees.join(', ') : '',
    };
  });
}
